import { css } from '@emotion/css';

import { SMALL_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const cardDeliveryClassName = css({
  paddingBottom: Spacing.XS,
  [SMALL_DEVICE_MQ]: {
    paddingBottom: 0,
  },
});
